import React, { useState } from "react";
import { Grid, Modal } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import KendoButton from "assets/theme/components/button/kendo";
import toast from "react-hot-toast";
import { AssetService } from "api/users.api";
import { modalContainerStyle } from "pages/components/common/Styles";

const DeleteVendorModel = ({ open, handleClose, asset, refresh, setRefresh }) => {
  console.log("Delete asset", asset);

  const [loading, setLoading] = useState(false);

  const handleDelete = async (event) => {
    try {
      setLoading(true);
      const response = await AssetService.deleteAsset(asset?.id);
      if (response?.data?.success == true) {
        setRefresh(!refresh);
        handleClose();
        toast.success("Asset deleted successfully.");
      } else {
        toast.error("Unable to delete Asset.");
      }
    } catch (error) {
      console.error(error);
      if (!!error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error(error?.message || "Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <SoftBox>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="assign-device-modal"
        aria-describedby="assign-device-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <SoftBox sx={modalContainerStyle}>
          <SoftTypography variant="h4" component="h2" gutterBottom mb={2}>
            Delete Vendor
          </SoftTypography>
          <SoftTypography
            variant="h6"
            fontWeight="regular"
            id="assign-device-modal-description"
            gutterBottom
          >
            Do you really want to delete {`${asset?.name}?`}
          </SoftTypography>
          <SoftBox>
            <Grid container justifyContent="flex-end" mt={3}>
              <Grid item lg={4}>
                <SoftButton onClick={handleClose} color="dark" sx={{ mr: 1 }}>
                  Cancel
                </SoftButton>
              </Grid>
              <Grid item lg={4}>
                <KendoButton
                  type="button"
                  label={"Delete"}
                  onClick={handleDelete}
                  loading={loading}
                />
              </Grid>
            </Grid>
          </SoftBox>
        </SoftBox>
      </Modal>
    </SoftBox>
  );
};

export default DeleteVendorModel;
